import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const items = [{
  left: 'Ver símbolos sin comprenderlos',
  right: 'Perder el significado profundo del arte'
}, {
  left: 'Elegir diseños sin contexto',
  right: 'Tatuajes sin historia ni conexión cultural'
}, {
  left: 'Perder referencias valiosas',
  right: 'Composiciones pobres o mal estructuradas'
}, {
  left: 'Acceder a información fragmentada',
  right: 'Confusión sobre mitos y criaturas'
}, {
  left: 'No conocer la tradición detrás del irezumi',
  right: 'Falta de respeto por el legado histórico'
}];
export function CostSection() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-39">
      <div className="max-w-4xl mx-auto" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-41">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-42">
            ⚖️ ¿Cuánto cuesta{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-43">
              no conocer
            </span>{' '}
            la historia completa?
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-bg-warm border border-line rounded-3xl overflow-hidden shadow-sm" data-id="element-44">
          <div className="grid grid-cols-2 bg-bg-warm border-b border-line" data-id="element-45">
            <div className="p-4 md:p-5 text-center font-bold text-ink text-sm md:text-base border-r border-line" data-id="element-46">
              Sin la colección
            </div>
            <div className="p-4 md:p-5 text-center font-bold text-rose text-sm md:text-base" data-id="element-47">
              Costo real
            </div>
          </div>
          {items.map((it, i) => <div key={i} className={`grid grid-cols-2 ${i !== items.length - 1 ? 'border-b border-line' : ''}`} data-id="element-48">
              <div className="p-4 md:p-5 flex items-start gap-2.5 border-r border-line" data-id="element-49">
                <XIcon className="w-4 h-4 text-rose flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-50" />
                <span className="text-sm md:text-base text-ink" data-id="element-51">{it.left}</span>
              </div>
              <div className="p-4 md:p-5 text-sm md:text-base text-ink-soft italic" data-id="element-52">
                {it.right}
              </div>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mt-10" data-id="element-53">
          <p className="font-serif-italic text-rose text-2xl md:text-3xl uppercase" data-id="element-54">
            ALGUNAS HISTORIAS SE ESCRIBEN CON PALABRAS. OTRAS QUEDAN GRABADAS EN
            LA PIEL.
          </p>
        </motion.div>
      </div>
    </section>;
}